module.exports = __webpack_public_path__ + "static/media/knolskape.99c655e0.png";